function CopyIcon({ color = "#fff", ...props }) {
  return (
    <span className="iiht-svg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        {...props}
      >
        <g
          id="Group_12449"
          data-name="Group 12449"
          transform="translate(-584 -591)"
        >
          <rect
            id="Rectangle_4107"
            data-name="Rectangle 4107"
            width="24"
            height="24"
            transform="translate(584 591)"
            fill="none"
          />
          <g id="copy" transform="translate(589 596)">
            <path
              id="Path_43738"
              data-name="Path 43738"
              d="M19,10v9H10V10h9m0-1H10a1,1,0,0,0-1,1v9a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V10A1,1,0,0,0,19,9Z"
              transform="translate(-6 -6)"
              fill={color}
            />
            <path
              id="Path_43739"
              data-name="Path 43739"
              d="M3.25,10.25h-1v-7a1,1,0,0,1,1-1h7v1h-7Z"
              transform="translate(-2.25 -2.25)"
              fill={color}
            />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default CopyIcon;
